<template>
  <b-modal
    id="surgery-template-delete-modal"
    content-class="delete-modal-content"
    title="Supprimer un modèle de compte-rendu"
    @ok="handleOk"
    ok-title="Supprimer"
    ok-variant="danger"
    cancel-title="Annuler"
  >
    <div v-if="selectedSurgeryTemplate !== null">
      Supprimer le modèle de compte-rendu "{{selectedSurgeryTemplate.name}}" ?
    </div>
  </b-modal>
</template>

<script>
import api from '../../services/api';

export default {

  name: 'SurgeryTemplateDeleteModal',

  props: {
    selectedSurgeryTemplate: Object
  },

  emits: ['didDeleteSurgeryTemplate'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {

      let surgeryTemplateName = this.selectedSurgeryTemplate.name

      api
        .delete(`/surgeryTemplate/${this.selectedSurgeryTemplate.id}`)
        .then(response => {
          this.$emit('didDeleteSurgeryTemplate')
          this.hideModal()
          this.successToast(`Modèle de compte-rendu \"${surgeryTemplateName}\" supprimé`)
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 2000,
              toaster: 'b-toaster-bottom-right'
            })
          }
        });
    },

    hideModal() {
      this.$bvModal.hide('surgery-template-delete-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/views/surgeryTemplate/SurgeryTemplateDeleteModal.vue